import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _excluded = ["ref"];
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es7.object.entries.js";
import React, { useContext, useMemo } from 'react';
import * as NerdWalletReactAnalytics from '@nerdwallet/analytics/react/impression';
import { COMPONENT_ANALYTICS_NAME } from '../lib/constants';
import { getRawAnalyticsPayload } from '../lib/utils/tracking';
/* eslint-disable camelcase */

/* eslint-enable camelcase */

/**
 * The base impression that wraps product cards.
 */
var BaseImpression = function BaseImpression(_ref) {
  var analytics = _ref.analytics,
      children = _ref.children,
      destinationUrl = _ref.destinationUrl,
      elementPosition = _ref.elementPosition,
      marketplaceInstitutionId = _ref.marketplaceInstitutionId,
      marketplaceOfferId = _ref.marketplaceOfferId,
      marketplaceProductId = _ref.marketplaceProductId,
      marketplaceProductType = _ref.marketplaceProductType,
      monetizable = _ref.monetizable,
      parentImpressionIdOverride = _ref.parentImpressionId,
      sectionName = _ref.sectionName,
      sectionPosition = _ref.sectionPosition,
      setProductCardImpressionId = _ref.setProductCardImpressionId;
  var impressionContext = useContext(NerdWalletReactAnalytics.ImpressionContext);
  var parentImpressionId = impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId;
  var impressionConfig = useMemo(function () {
    return {
      entityName: COMPONENT_ANALYTICS_NAME,
      eventType: 'product_impression',
      payload: _objectSpread(_objectSpread({}, getRawAnalyticsPayload(analytics)), Object.fromEntries(Object.entries({
        destination_url: destinationUrl,
        element_position: elementPosition,
        marketplace_institution_id: marketplaceInstitutionId,
        marketplace_offer_id: marketplaceOfferId,
        marketplace_product_id: marketplaceProductId,
        marketplace_product_type: marketplaceProductType,
        monetizable: monetizable,
        parent_impression_id: parentImpressionIdOverride || parentImpressionId,
        section_name: sectionName,
        section_position: sectionPosition
      }).filter(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            trkValue = _ref3[1];

        return trkValue != null;
      }))),
      refireOnEventChange: true
    };
  }, [analytics, destinationUrl, elementPosition, marketplaceInstitutionId, marketplaceOfferId, marketplaceProductId, marketplaceProductType, monetizable, parentImpressionId, parentImpressionIdOverride, sectionName, sectionPosition]);

  var _NerdWalletReactAnaly = NerdWalletReactAnalytics.useImpression(impressionConfig),
      ref = _NerdWalletReactAnaly.ref,
      impression = _objectWithoutProperties(_NerdWalletReactAnaly, _excluded);

  if (setProductCardImpressionId) {
    setProductCardImpressionId(impression === null || impression === void 0 ? void 0 : impression.impressionId);
  }

  return /*#__PURE__*/React.createElement(NerdWalletReactAnalytics.ImpressionContext.Provider, {
    value: impression
  }, /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, children));
};

if (process.env.NODE_ENV !== 'production') {
  /* eslint-disable-next-line global-require, @typescript-eslint/no-var-requires */
  var PropTypes = require('prop-types');

  BaseImpression.propTypes = {
    analytics: PropTypes.shape({
      payload: PropTypes.shape({
        destination_url: PropTypes.string,
        element_position: PropTypes.number,
        section_name: PropTypes.string,
        section_position: PropTypes.number
      })
    }),
    children: PropTypes.node.isRequired,
    destinationUrl: PropTypes.string,
    elementPosition: PropTypes.number,
    marketplaceInstitutionId: PropTypes.string,
    marketplaceOfferId: PropTypes.string,
    marketplaceProductId: PropTypes.string,
    marketplaceProductType: PropTypes.string,
    monetizable: PropTypes.string,
    parentImpressionId: PropTypes.string,
    sectionName: PropTypes.string,
    sectionPosition: PropTypes.string
  };
}

export default BaseImpression;